import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import BeforeAfter from "@/components/BeforeAfter";
import Showcase from "@/components/Showcase";
import { Marquee, Services, Process, Founder, Faq } from "@/components/Sections";
import { Contact, Footer } from "@/components/Contact";
import DemoDialog from "@/components/DemoDialog";
import BookingDialog from "@/components/BookingDialog";
import FloatingDock from "@/components/FloatingDock";

export default function Home() {
  const { hash } = useLocation();
  useEffect(() => {
    document.title = "Webhaus – Webdesign aus Wien | Kostenlose Website-Demo in 24 Stunden";
    if (!hash) return undefined;
    const t = setTimeout(() => document.getElementById(hash.slice(1))?.scrollIntoView(), 120);
    return () => clearTimeout(t);
  }, [hash]);

  return (
    <>
      <a href="#main" className="sr-only z-50 rounded bg-ink px-4 py-2 text-paper focus:not-sr-only focus:fixed focus:left-4 focus:top-4">Zum Inhalt springen</a>
      <Header />
      <main id="main">
        <Hero />
        <Marquee />
        <BeforeAfter />
        <Showcase />
        <Services />
        <Process />
        <Founder />
        <Faq />
        <Contact />
      </main>
      <div id="site-footer-anchor"><Footer /></div>
      <DemoDialog />
      <BookingDialog />
      <FloatingDock />
    </>
  );
}
